import React, { Fragment, useState } from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import home_bg_slider from "../../../assets/images/home-bg.jpg";
import clientconfigwebapp from "../../../clientconfigwebapp";

const Home_Baner_Search = (props) => {
    const [selectedCategory, setSelectedCategory] = useState('');
    const [searchTerm, setSearchTerm] = useState('');

    const handleSubmit = (event) => {
        event.preventDefault();
        const category = selectedCategory ? selectedCategory : '';
        const search = searchTerm ? searchTerm : '';
        const url = `${clientconfigwebapp.webappurl}products/${category}/?search=${search}`;
        let urlend=String(url).replaceAll("//?","/?");
        window.location.href = urlend;
    };

    return (
        <Fragment>
            <div className={"Home_Baner_search"} style={{ "backgroundImage": `url(${home_bg_slider})` }}>
                <div className={"Home_Baner_search_continer"}>
                    <div className="titles_search_home">
                        <h1 className={"Baner-h1-home"}>بازارانو</h1>
                        <div className="divider"></div>
                        <h2 className={"Baner-h2-home"}>خرید و فروش عمده محصولات</h2>
                        <h3 className={"Baner-h3-home"}>ارتباط مستقیم با خریداران و فروشندگان عمده</h3>
                    </div>
                    <div className={"box-input-home-Baner-search"}>
                        <form onSubmit={handleSubmit} style={{ "width": "100%", "display": "flex" }}>
                            <Select
                                displayEmpty
                                name="shipping_time"
                                className={"selectoption-Baner-search"}
                                value={selectedCategory}
                                onChange={(e) => setSelectedCategory(e.target.value)}
                            >
                                <MenuItem value=""><span className={"selectoption-item-Baner-search"}><em>همه دسته بندی ها</em></span></MenuItem>
                                {props.data_category_box && props.data_category_box.map((item_post, index) => (
                                    <MenuItem key={index} value={String(item_post.id)}>
                                        <span className={"selectoption-item-Baner-search"}>{item_post.name}</span>
                                    </MenuItem>
                                ))}
                            </Select>
                            <input
                                name="search"
                                className={"input-Baner-search"}
                                type="text"
                                placeholder={"دنبال چه محصولی هستید؟"}
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <button className={"btn-Baner-search btn-bk-new-hover-blue"} type="submit">
                                <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19.485 20.154L13.223 13.892C12.723 14.318 12.148 14.6476 11.498 14.881C10.848 15.1143 10.1947 15.231 9.53801 15.231C7.93668 15.231 6.58135 14.6766 5.47201 13.568C4.36268 12.4586 3.80801 11.1036 3.80801 9.50298C3.80801 7.90232 4.36201 6.54665 5.47001 5.43598C6.57868 4.32465 7.93335 3.76898 9.53401 3.76898C11.1353 3.76898 12.4913 4.32365 13.602 5.43298C14.7127 6.54232 15.268 7.89798 15.268 9.49998C15.268 10.1946 15.145 10.867 14.899 11.517C14.6523 12.167 14.329 12.723 13.929 13.185L20.191 19.446L19.485 20.154ZM9.53801 14.23C10.8647 14.23 11.985 13.7733 12.899 12.86C13.8123 11.9466 14.269 10.8263 14.269 9.49898C14.269 8.17231 13.8123 7.05232 12.899 6.13898C11.9857 5.22565 10.8657 4.76898 9.53901 4.76898C8.21235 4.76898 7.09201 5.22565 6.17801 6.13898C5.26468 7.05232 4.80801 8.17231 4.80801 9.49898C4.80801 10.8256 5.26468 11.9456 6.17801 12.859C7.09135 13.7723 8.21135 14.23 9.53801 14.23Z" fill="white" />
                                </svg>
                                <span className={"home_search_text_btn"}>جستجو</span>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default Home_Baner_Search;
